import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { pickBy, get } from 'lodash';
import {
  getOnboardingState,
  getEcapState,
  getAuthState,
  getAdminState,
} from '../../store/selectors';
import {
  getUserData,
  getCurrentUserId,
  getRolePermissions,
} from '../../store/actions';
import HamburgerMenu from '../utility/HamburgerMenu';
import SchoolLogo from '../utility/SchoolLogo';
import { getHeaderListItems } from '../utility/headerUtil';
import { advisorDashBaseCopy } from '../../copy/advisor-dashboard/advisor-dashboard-base.json';
import Loading from '../utility/Loading';

export class AdvisorDashboardBase extends React.Component {
  _isMounted = false;

  constructor(props) {
    super(props);
    this.state = {
      activeElement: '',
      allowedMenuItems: [],
      loading: true,
    };
  }

  componentDidMount = async () => {
    this.getActiveElement();
    const userId = await this.props.getCurrentUserId(this.props.auth.jwtToken);
    await this.props.getRolePermissions(this.props.auth.jwtToken);
    await this.props.getUserData(userId, this.props.auth.jwtToken);
    const allowedMenuItems = Object.keys(
      pickBy(this.props.admin.permissions.accessibleContent)
    );
    this.setState({
      allowedMenuItems,
      loading: false,
    });
  };

  getActiveElement = () => {
    let active;
    Object.keys(this.elementsAndEndpoints).map((key) => {
      if (
        this.elementsAndEndpoints[key] ===
        window.location.pathname.slice(
          window.location.pathname.lastIndexOf('/') + 1,
          window.location.pathname.length
        )
      ) {
        active = key;
      }
      return active;
    });
    this.setState({
      activeElement: active,
    });
  };

  activeElement = {
    color: `${this.props.tenant.primary}`,
    borderBottom: `3px solid ${this.props.tenant.secondary}`,
  };

  borderTopSecondary = {
    borderTop: `9px solid ${this.props.tenant.secondary}`,
  };

  displayMenuItem = (menuItem) => {
    const { activeElement } = this.state;
    return (
      <div key={menuItem} className="menu-item">
        <button
          type="button"
          tabIndex={0}
          onClick={() => {
            this.handleNewElementActivated(menuItem);
          }}
          onKeyDown={(e) => {
            if (['Enter'].includes(e.key))
              this.handleNewElementActivated(menuItem);
          }}
          className="menu-item-title"
          style={menuItem === activeElement ? this.activeElement : null}
        >
          {menuItem}
        </button>
      </div>
    );
  };

  // build object with endpoints and menuItems, use this to history.push to proper endpoint
  elementsAndEndpoints = {
    [`${advisorDashBaseCopy.menuItems[0]}`]: 'reporting',
    [`${advisorDashBaseCopy.menuItems[1]}`]: 'notifications',
    [`${advisorDashBaseCopy.menuItems[2]}`]: 'users',
    [`${advisorDashBaseCopy.menuItems[3]}`]: 'tenants',
    [`${advisorDashBaseCopy.menuItems[4]}`]: 'careers',
    [`${advisorDashBaseCopy.menuItems[5]}`]: 'degrees',
    [`${advisorDashBaseCopy.menuItems[6]}`]: 'game-images',
    [`${advisorDashBaseCopy.menuItems[7]}`]: 'career-categories-and-images',
  };

  get tenantName() {
    return this.props.tenant.name;
  }

  get onboarding() {
    return this.props.onboarding;
  }

  get educationLevel() {
    return get(this.onboarding, 'userData.user.educationLevel');
  }

  handleNewElementActivated = (menuItem) => {
    this.setState({
      activeElement: menuItem,
    });
    this.props.history.push(`${this.elementsAndEndpoints[menuItem]}`);
  };

  getListItems = () => {
    return getHeaderListItems({
      educationLevel: this.educationLevel,
      tenantName: this.tenantName,
      isOnAdvisorDashboard: true,
    });
  };

  render() {
    const { allowedMenuItems, loading } = this.state;
    return loading ? (
      <Loading height="100vh" />
    ) : (
      <>
        <div
          className="advisor-dashboard-base-dashboard-header"
          style={this.borderTopSecondary}
        >
          <div className="left-side-header">
            <SchoolLogo />
          </div>
          <HamburgerMenu
            tenant={this.props.tenant}
            gtmLocation="dashboard hamburger menu"
            listItems={this.getListItems()}
          />
        </div>
        {!this.props.location.pathname.includes('userProfile') && (
          <div id="advisor-dashboard-base">
            <h1 className="advisor-dashboard-header">
              {advisorDashBaseCopy.header}
            </h1>
            <div className="advisor-dashboard-menu" style={{ width: '100%' }}>
              {allowedMenuItems.map((menuItem) => {
                return this.displayMenuItem(menuItem);
              })}
            </div>
          </div>
        )}
      </>
    );
  }
}

function mapStateToProps(state) {
  const onboarding = getOnboardingState(state);
  const auth = getAuthState(state);
  const ecap = getEcapState(state);
  const admin = getAdminState(state);
  return { onboarding, ecap, auth, admin };
}

export default withRouter(
  connect(mapStateToProps, {
    getCurrentUserId,
    getUserData,
    getRolePermissions,
  })(AdvisorDashboardBase)
);
